import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { PublicLayout } from "@/components/layout";
import { AdminLayout } from "@/components/layout";
import ProtectedRoute from "@/components/shared/ProtectedRoute";

// Public pages
const HomePage = lazy(() => import("@/pages/public/HomePage"));
const AboutPage = lazy(() => import("@/pages/public/AboutPage"));
const PortfolioPage = lazy(() => import("@/pages/public/PortfolioPage"));
const QuotePage = lazy(() => import("@/pages/public/QuotePage"));
const AppointmentPage = lazy(() => import("@/pages/public/AppointmentPage"));
const SupportPage = lazy(() => import("@/pages/public/SupportPage"));
const TermsPage = lazy(() => import("@/pages/public/TermsPage"));
const PrivacyPage = lazy(() => import("@/pages/public/PrivacyPage"));
const SolutionsPage = lazy(() => import("@/pages/public/SolutionsPage"));
const SitiosWebPage = lazy(() => import("@/pages/public/SitiosWebPage"));
const SoftwareAMedidaPage = lazy(() => import("@/pages/public/SoftwareAMedidaPage"));
const AutomatizacionDatosPage = lazy(() => import("@/pages/public/AutomatizacionDatosPage"));

// Admin pages
const LoginPage = lazy(() => import("@/pages/admin/LoginPage"));
const TeamModule = lazy(() => import("@/pages/admin/TeamModule"));
const PortfolioModule = lazy(() => import("@/pages/admin/PortfolioModule"));
const CRMModule = lazy(() => import("@/pages/admin/CRMModule"));
const AppointmentsModule = lazy(() => import("@/pages/admin/AppointmentsModule"));
const TicketsModule = lazy(() => import("@/pages/admin/TicketsModule"));

function RouteFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-[var(--color-accent)] border-t-transparent" />
    </div>
  );
}

function AppRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        {/* Public routes */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/nosotros" element={<AboutPage />} />
          <Route path="/portafolio" element={<PortfolioPage />} />
          <Route path="/soluciones" element={<SolutionsPage />} />
          <Route path="/soluciones/sitios-web" element={<SitiosWebPage />} />
          <Route path="/soluciones/software-a-medida" element={<SoftwareAMedidaPage />} />
          <Route path="/soluciones/automatizacion-datos" element={<AutomatizacionDatosPage />} />
          <Route path="/cotizar" element={<QuotePage />} />
          <Route path="/agendar" element={<AppointmentPage />} />
          <Route path="/soporte" element={<SupportPage />} />
          <Route path="/terminos" element={<TermsPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
        </Route>

        {/* Admin routes */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/crm" replace />} />
          <Route path="team" element={<TeamModule />} />
          <Route path="portafolio" element={<PortfolioModule />} />
          <Route path="crm" element={<CRMModule />} />
          <Route path="appointments" element={<AppointmentsModule />} />
          <Route path="tickets" element={<TicketsModule />} />
        </Route>

        {/* Catch-all: redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
